import { clearAccessToken, clearSessionId, saveAccessToken, saveSessionId, setActivePeriodId } from "../../../api/apiClient";
import { clearQueueToken } from "../../../helpers/queueToken";
import { ILoginRespone } from "../../../model/respone/auth/ILoginRespone";
import { eAuthActionTypeDefine } from "../../action-types/auth/IAuthActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const authActions = {
    ...generateActions(eAuthActionTypeDefine, "AUTH"),
    ...generateActionForKey(eAuthActionTypeDefine, "AUTH", "LOGIN_SUCCESS", (payload: ILoginRespone) => {
        saveAccessToken(payload.access_token);
        localStorage.setItem("user_info", JSON.stringify(payload.user));
        localStorage.setItem("expires_at", payload.expires_at);
        // Buộc đổi mật khẩu yếu — lưu cờ để giữ qua F5 (SessionRestorer đọc lại). Nguồn chốt chặn
        // vẫn là claim pwd_must_change trong JWT phía server; localStorage chỉ lái UI.
        if (payload.must_change_password) {
            localStorage.setItem("must_change_password", "1");
            localStorage.setItem("password_weak_reason", payload.password_weak_reason || "");
        } else {
            localStorage.removeItem("must_change_password");
            localStorage.removeItem("password_weak_reason");
        }
        // SSO VNPT: lưu id_token để dùng làm id_token_hint khi logout (RP-initiated logout). Các
        // luồng khác không trả sso_id_token → xoá để không dùng nhầm hint cũ.
        if (payload.sso_id_token) sessionStorage.setItem("sso_id_token", payload.sso_id_token);
        else sessionStorage.removeItem("sso_id_token");
        // Single-device login: lưu sid phiên để lọc ForceLogout của chính mình. undefined khi tính năng tắt.
        saveSessionId(payload.session_id);
        // Multi-period: bắt đầu phiên sạch — không kế thừa đợt của SV trước (resolve lại từ /periods).
        setActivePeriodId(null);
    }),
    ...generateActionForKey(eAuthActionTypeDefine, "AUTH", "RESTORE_SESSION", (payload: ILoginRespone) => {
        saveAccessToken(payload.access_token);
        localStorage.setItem("user_info", JSON.stringify(payload.user));
        localStorage.setItem("expires_at", payload.expires_at);
    }),
    ...generateActionForKey(eAuthActionTypeDefine, "AUTH", "PASSWORD_CHANGED", (payload: { access_token: string; expires_at: string }) => {
        // Đổi mật khẩu xong: thay token mới (đã bỏ pwd_must_change) + xoá cờ buộc đổi.
        saveAccessToken(payload.access_token);
        if (payload.expires_at) localStorage.setItem("expires_at", payload.expires_at);
        localStorage.removeItem("must_change_password");
        localStorage.removeItem("password_weak_reason");
    }),
    ...generateActionForKey(eAuthActionTypeDefine, "AUTH", "LOGOUT", () => {
        clearAccessToken();
        // Cũng clear queue token để không bị stale sau re-login. Middleware backend vẫn check
        // token theo SV nên không phải security bug, nhưng tránh confusion với UI/dev.
        clearQueueToken();
        // Multi-period: clear đợt đang chọn để SV khác login không kế thừa X-Period-Id cũ.
        setActivePeriodId(null);
        localStorage.removeItem("user_info");
        localStorage.removeItem("expires_at");
        localStorage.removeItem("must_change_password");
        localStorage.removeItem("password_weak_reason");
        // id_token SSO chỉ phục vụ logout; dọn luôn cùng phiên (Header đã đọc trước khi dispatch).
        sessionStorage.removeItem("sso_id_token");
        // Single-device login: dọn sid phiên.
        clearSessionId();
    }),
};
